// IMPORTANT: this file was generated using SVGR, please do not edit directly. Refer to the icon README.md for more info.
 
 
import type { FC } from 'react';

import { Icon, type IconProps } from './../IconWrapper';

const SvgPlayIcon: FC<IconProps> = ({ color, size, verticalAlign }) => (
  <Icon color={color} size={size} verticalAlign={verticalAlign}>
    <path d="m19.9 10.29-14-7.08c-.62-.31-1.36-.28-1.95.08S3 4.3 3 4.99v14a2.01 2.01 0 0 0 2 2c.3 0 .61-.07.89-.21l14-6.93a1.996 1.996 0 0 0 .01-3.57Z" />
  </Icon>
);
export default SvgPlayIcon;
SvgPlayIcon.displayName = 'SvgPlayIcon';
